module.exports = __webpack_public_path__ + "static/media/58_tn.9bbc60c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/58_tn.jpg
// module id = 366
// module chunks = 0